import { Routes, Route, Navigate } from "react-router-dom";

// Documentation pages
import { DocsIndex } from "@/pages/index";
import { Welcome } from "@/pages/welcome";
import { ConnectWallet } from "@/pages/connect-wallet";
import { FirstDeposit } from "@/pages/first-deposit";
import { Withdrawals } from "@/pages/withdrawals";
import { FirstTrade } from "@/pages/first-trade";
import { Interface } from "@/pages/interface";
import { Perpetuals } from "@/pages/perpetuals";
import { Leverage } from "@/pages/leverage";
import { MarginLiquidation } from "@/pages/margin-liquidation";
import { FundingRates } from "@/pages/funding-rates";
import { OrderTypes } from "@/pages/order-types";
import { PositionManagement } from "@/pages/position-management";
import { Markets } from "@/pages/markets";
import { Fees } from "@/pages/fees";
import { AccountDocs } from "@/pages/account";
import { Charts } from "@/pages/charts";
import { PerformanceLab } from "@/pages/performance-lab";
import { WalletSecurity } from "@/pages/wallet-security";
import { UnderstandingRisks } from "@/pages/understanding-risks";

// Support & company pages
import { SupportIndex } from "@/pages/support/index";
import { Contact } from "@/pages/support/contact";
import { FAQ } from "@/pages/support/faq";
import { Feedback } from "@/pages/support/feedback";
import { ApiAccess } from "@/pages/support/api-access";
import { About } from "@/pages/support/about";
import { Careers } from "@/pages/support/careers";
import { MediaKit } from "@/pages/support/media-kit";
import { Terms } from "@/pages/support/terms";
import { Privacy } from "@/pages/support/privacy";

// Detect which context we're in for the index route
const isSupport = window.location.pathname.startsWith("/support");

export default function App() {
  return (
    <Routes>
      {/* Index route renders based on context */}
      <Route path="/" element={isSupport ? <SupportIndex /> : <DocsIndex />} />

      {/* Documentation routes (served when basename is /docs) */}
      <Route path="/welcome" element={<Welcome />} />
      <Route path="/connect-wallet" element={<ConnectWallet />} />
      <Route path="/first-deposit" element={<FirstDeposit />} />
      <Route path="/withdrawals" element={<Withdrawals />} />
      <Route path="/first-trade" element={<FirstTrade />} />
      <Route path="/interface" element={<Interface />} />
      <Route path="/perpetuals" element={<Perpetuals />} />
      <Route path="/leverage" element={<Leverage />} />
      <Route path="/margin-liquidation" element={<MarginLiquidation />} />
      <Route path="/funding-rates" element={<FundingRates />} />
      <Route path="/order-types" element={<OrderTypes />} />
      <Route path="/position-management" element={<PositionManagement />} />
      <Route path="/markets" element={<Markets />} />
      <Route path="/fees" element={<Fees />} />
      <Route path="/account" element={<AccountDocs />} />
      <Route path="/charts" element={<Charts />} />
      <Route path="/performance-lab" element={<PerformanceLab />} />
      <Route path="/wallet-security" element={<WalletSecurity />} />
      <Route path="/understanding-risks" element={<UnderstandingRisks />} />

      {/* Support & company routes (served when basename is /support) */}
      {/* Note: When basename is /support, "/" renders SupportIndex.
          When basename is /docs, "/" renders DocsIndex.
          Both route sets exist but only the matching context's routes will be used. */}
      <Route path="/contact" element={<Contact />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/feedback" element={<Feedback />} />
      <Route path="/api-access" element={<ApiAccess />} />
      <Route path="/about" element={<About />} />
      <Route path="/careers" element={<Careers />} />
      <Route path="/media-kit" element={<MediaKit />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />

      {/* Catch-all: redirect unmatched URLs to index */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
